export default __webpack_public_path__ + "static/media/3233 knife block A side.799dcf84.png";